<template>
  <footer class="el-footer footer" style="height: 64px;">
    <div class="content"><span @click="officialWebsite">© 五创循环</span> <span
      @click="goGovPage"
    >版权所有 / 湘ICP备2022025132号</span></div>
  </footer>
</template>

<script>
import {mapGetters} from 'vuex'


export default {
  components: {},
  computed: {
    ...mapGetters([])
  },
  data() {
    return {}
  },
  methods: {
    goGovPage() {
      window.open('https://beian.miit.gov.cn')
    },
    officialWebsite() {
      window.open('https://5crecycle.com.cn/')
    }
  }
}
</script>

<style scoped>
.footer {
  font-size: 14px;
  color: #666;
  font-weight: 400;
  background: #fafafa;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.el-footer {
  padding: 0 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.footer .content {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppFooter.vue